export const alertCodes = {
  // DEFAULT ERRORS
  "DEFAULT": {
    "type": "error",
    "en": "An unexpected error occurred.",
    "es": "Ocurrió un error inesperado."
  },
  "NETWORK_ERROR": {
    "type": "error",
    "en": "Cannot connect to the server.",
    "es": "No se puede conectar con el servidor."
  },
  "TOKEN_END": {
    "type": "error",
    "en": "Your session has expired. Please log in again.",
    "es": "Tu sesión ha expirado. Por favor, inicia sesión de nuevo."
  },
  "INTERNAL_ERROR": {
    "type": "error",
    "en": "Internal server error. Please try again later.",
    "es": "Error interno del servidor. Por favor, inténtalo de nuevo más tarde."
  },

  // USER ERRORS
  "USERNAME_ALREADY_EXISTS": {
    "type": "error",
    "en": "Username already exists.",
    "es": "El nombre de usuario ya existe."
  },
  "PASSWORD_DONT_MATCH": {
    "type": "error",
    "en": "Passwords do not match.",
    "es": "Las contraseñas no coinciden."
  },
  "MUST_ACCEPT_TERMS": {
    "type": "error",
    "en": "You must accept the terms and conditions to continue.",
    "es": "Debes aceptar los términos y condiciones para continuar."
  },
  "BIRTH_DATE_REQUIRED": {
    "type": "error",
    "en": "Birth date is required.",
    "es": "La fecha de nacimiento es obligatoria."
  },
  "BIRTH_DATE_MUST_BE_OVER_18": {
    "type": "error",
    "en": "You must be over 18 years old to register.",
    "es": "Debes tener más de 18 años para registrarte."
  },
  "INVITATION_CODE_REQUIRED": {
    "type": "error",
    "en": "Invitation code is required.",
    "es": "El código de invitación es obligatorio."
  },
  "INVITATION_CODE_EXPIRED": {
    "type": "error",
    "en": "Invitation code has expired or reached its usage limit.",
    "es": "El código de invitación ha expirado o alcanzó su límite de uso."
  },
  "OPEN_EMAIL_VERIFICATION": {
    "type": "success",
    "en": "Please verify your email address to continue.",
    "es": "Por favor, verifica tu dirección de correo electrónico para continuar."
  },
  "INVALID_TOKEN": {
    "type": "error",
    "en": "Invalid token. Please try again.",
    "es": "Token inválido. Por favor, inténtalo de nuevo."
  },
  "ACCOUNT_ALREADY_VERIFIED": {
    "type": "error",
    "en": "Your account is already verified.",
    "es": "Tu cuenta ya está verificada."
  },
  "EMAIL_VERIFICATION_SUCCESSFULLY": {
    "type": "success",
    "en": "Email verification successful. You can now log in.",
    "es": "Verificación de correo electrónico exitosa. Ahora puedes iniciar sesión."
  },
  "PASSWORD_RESET_EMAIL_REQUIRED": {
    "type": "error",
    "en": "Email is required to reset your password.",
    "es": "El correo electrónico es obligatorio para restablecer tu contraseña."
  },
  "PASSWORD_RESET_EMAIL_SENT": {
    "type": "success",
    "en": "Password reset email sent. Please check your inbox.",
    "es": "Correo electrónico de restablecimiento de contraseña enviado. Por favor, revisa tu bandeja de entrada."
  },
  "FORGOT_PASSWORD_COMPLETED": {
    "type": "success",
    "en": "Password reset successfully. You can now log in with your new password.",
    "es": "Contraseña restablecida con éxito. Ahora puedes iniciar sesión con tu nueva contraseña."
  },
  "USER_NOT_VERIFIED": {
    "type": "error",
    "en": "Your account is not verified. Please check your email for the verification link.",
    "es": "Tu cuenta no está verificada. Por favor, revisa tu correo electrónico para el enlace de verificación."
  },
  "USER_BLOCKED": {
    "type": "error",
    "en": "Your account has been blocked. Please contact support for assistance.",
    "es": "Tu cuenta ha sido bloqueada. Por favor, contacta con el soporte para obtener ayuda."
  },
  "ERROR_LOGIN": {
    "type": "error",
    "en": "Login failed. Please try again.",
    "es": "Error de inicio de sesión. Por favor, reintentente de nuevo."
  },
  "ERROR_REGISTER": {
    "type": "error",
    "en": "Registration failed. Please try again.",
    "es": "Error de registro. Por favor, reintentente de nuevo."
  },
  "USER_NOT_FOUND": {
    "type": "error",
    "en": "User not found.",
    "es": "Usuario no encontrado."
  },
  "USER_ALREADY_EXISTS": {
    "type": "error",
    "en": "User already exists.",
    "es": "El usuario ya existe."
  },
  "EMAIL_ALREADY_EXISTS": {
    "type": "error",
    "en": "Email already exists.",
    "es": "El correo electrónico ya existe."
  },
  "INVALID_USERNAME_LENGTH": {
    "type": "error",
    "en": "Username must be between 3 and 20 characters.",
    "es": "El nombre de usuario debe tener entre 3 y 20 caracteres."
  },
  "INVALID_USERNAME_FORMAT": {
    "type": "error",
    "en": "Username can only contain alphanumeric characters and underscores.",
    "es": "El nombre de usuario solo puede contener caracteres alfanuméricos y guiones bajos."
  },
  "INVALID_PASSWORD_FORMAT": {
    "type": "error",
    "en": "Password must be at least 8 characters long and contain at least one letter, one number.",
    "es": "La contraseña debe tener al menos 8 caracteres y contener al menos una letra, un número."
  },
  "INVALID_EMAIL_FORMAT": {
    "type": "error",
    "en": "Invalid email format.",
    "es": "Formato de correo electrónico no válido."
  },

  // PROFILE
  "INCORRECT_PASSWORD": {
    "type": "error",
    "en": "Incorrect current password.",
    "es": "Contraseña actual incorrecta."
  },
  "PASSWORD_CHANGE_FAILED": {
    "type": "error",
    "en": "Password change failed. Please try again.",
    "es": "Error al cambiar la contraseña. Por favor, reintentente de nuevo."
  },
  "PASSWORD_CHANGED_SUCCESSFULLY": {
    "type": "success",
    "en": "Password changed successfully.",
    "es": "Contraseña cambiada con éxito."
  },

  // ACTIVITY ERRORS
  "INVALID_FILE_FORMAT": {
    "type": "error",
    "en": "Invalid file format. Please upload a TCX file.",
    "es": "Formato de archivo no válido. Por favor, sube un archivo TCX."
  },
  "ERROR_UPLOAD_ACTIVITY": {
    "type": "error",
    "en": "Error uploading activity. Please try again.",
    "es": "Error al subir la actividad. Por favor, reintentente de nuevo."
  },
  "ACTIVITY_NOT_FOUND": {
    "type": "error",
    "en": "Activity not found.",
    "es": "Actividad no encontrada."
  },
  "ACTIVITY_NOT_HAVE_ACCESS": {
    "type": "error",
    "en": "You do not have access to this activity.",
    "es": "No tienes acceso a esta actividad."
  },


};
